import React from 'react';
import styled from 'styled-components';
import ReactLoader from 'components/Loader';
import { MdKeyboardArrowUp } from 'react-icons/md';

const DividerWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.6rem 0;
  z-index: 20;
  pointer-events: none;
`;

const LinesContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

/* linha*/
const Line = styled.div.attrs((props) => ({
  style: {
    height: `${props.lineThickness}px`,
    background: props.lineColor,
    opacity: props.lineOpacity
  }
}))`
  flex: 1;
  min-width: 0;
`;

/* botão central */
const CenterButton = styled.button`
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #ffffff;
  border: 2px solid ${(p) => p.lineColor || '#2f3b40'};
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  z-index: 30;
  outline: none;
  transition: transform 120ms ease;
  margin: 0 ${(p) => (typeof p.gap === 'number' ? `${p.gap}px` : p.gap)};

  &:hover {
    transform: translateY(-2px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
    transform: none;
  }
`;

const ResponsiveWrapper = styled.div`
  width: 100%;
  max-width: 100%;
`;

const LoadPreviousConversationDivider = ({
  onClick,
  loading = false,
  disabled = false,
  title = 'Carregar conversa anterior',
  gap = 16,
  lineThickness = 2,
  lineColor = '#2f3b40',
  lineOpacity = 0.45
}) => {
  return (
    <ResponsiveWrapper aria-hidden={false}>
      <DividerWrapper title={title}>
        <LinesContainer>
          <Line
            lineThickness={lineThickness}
            lineColor={lineColor}
            lineOpacity={lineOpacity}
            style={{ marginRight: gap }}
          />
          <CenterButton
            onClick={(e) => {
              e.stopPropagation();
              if (!disabled && !loading && onClick) onClick();
            }}
            disabled={disabled || loading}
            aria-label={title}
            gap={gap}
            lineColor={lineColor}
          >
            {loading ? (
              <ReactLoader width="18px" height="18px" />
            ) : (
              <MdKeyboardArrowUp size={22} color="#32325d" />
            )}
          </CenterButton>
          <Line
            lineThickness={lineThickness}
            lineColor={lineColor}
            lineOpacity={lineOpacity}
            style={{ marginLeft: gap }}
          />
        </LinesContainer>
      </DividerWrapper>
    </ResponsiveWrapper>
  );
};

export default LoadPreviousConversationDivider;
